import React from 'react'
import { useState } from 'react'

function Search() {
  const [products, setProducts] = useState();
  const [stores,setStores] = useState();
  return (
    <div>
      Hi get ready to search on the V2 of this app ;-)
    </div>
  )
}

export default Search
